// extracted by mini-css-extract-plugin
export default {"fullWidth":"Mm-z","image":"Nm-z","lazyLoadPicture":"Om-z","lazyLoadSpinner":"Pm-z","lazyLoadSpin":"Qm-z","lazyLoadImage":"Rm-z","hasStyledAspectRatio":"Sm-z"};